import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { NkStack, NkHeading, NkGroup } from '@/core/components';



export default /*#__PURE__*/_defineComponent({
  __name: 'NkEntry',
  props: {
  title: {
    type: String,
    default: '',
  },
  position: {
    type: String,
    default: 'apart'
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkStack), { spacing: 4 }, {
    default: _withCtx(() => [
      (props.title)
        ? (_openBlock(), _createBlock(_unref(NkGroup), {
            key: 0,
            position: props.position
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkHeading), { type: "small-italic" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(NkGroup), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "actions")
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["position"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})